import { render, staticRenderFns } from "./relCostDialog.vue?vue&type=template&id=3ecff1ea"
import script from "./relCostDialog.vue?vue&type=script&lang=js"
export * from "./relCostDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports